import { render } from "./TextBlock.vue?vue&type=template&id=44f9c687"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "44f9c687"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44f9c687', script)) {
    api.reload('44f9c687', script)
  }
  
  module.hot.accept("./TextBlock.vue?vue&type=template&id=44f9c687", () => {
    api.rerender('44f9c687', render)
  })

}

script.__file = "src/components/blocks/TextBlock.vue"

export default script